import { ReactNode } from 'react'
import { Container, Floating } from './styles'

interface IProps {
  children: ReactNode
  text: string

  position?: 'top' | 'left' | 'bottom' | 'right'
  className?: string
}

const TooltipWrapper = (props: IProps) => {
  return (
    <Container>
      {props.children}
      <Floating className={props.className} data-position={props.position || 'bottom'}>
        {props.text}
      </Floating>
    </Container>
  )
}

export default TooltipWrapper
